import { atom } from 'jotai';

export const inAppIntegrationLoadingAtom = atom<boolean>(false);
